// extracted by mini-css-extract-plugin
module.exports = {"managementCard":"ManagementCard_managementCard__4lLZf","img":"ManagementCard_img__5rd5V","title":"ManagementCard_title__1qrqm","text":"ManagementCard_text__19U7U"};